import { useEffect, useMemo } from 'react';

import { AppShell } from '@/components/layout/AppShell';
import { useAuth } from '@/stores/authStore';
import { useNav } from '@/stores/navStore';
import { routesForRole } from './routes';
import { DashboardScreen } from '@/screens/dashboard/DashboardScreen';
import { ProductosVentaScreen } from '@/screens/inventario/ProductosVentaScreen';
import { InsumosInternosScreen } from '@/screens/inventario/InsumosInternosScreen';
import { ContabilidadScreen } from '@/screens/contabilidad/ContabilidadScreen';
import { SolicitudesScreen } from '@/screens/solicitudes/SolicitudesScreen';
import { ProveedoresScreen } from '@/screens/proveedores/ProveedoresScreen';
import { ComparativaPrecios } from '@/screens/proveedores/ComparativaPrecios';
import { ArchivosScreen } from '@/screens/archivos/ArchivosScreen';
import { AlertasScreen } from '@/screens/dashboard/AlertasScreen';
import { ConfiguracionScreen } from '@/screens/configuracion/ConfiguracionScreen';
import { PetshopsScreen } from '@/screens/petshops/PetshopsScreen';
import { FormulariosScreen } from '@/screens/formularios/FormulariosScreen';
import { EstadisticasScreen } from '@/screens/estadisticas/EstadisticasScreen';
import { SalidasScreen } from '@/screens/salidas/SalidasScreen';
import { JaulasScreen } from '@/screens/jaulas/JaulasScreen';

const SCREENS: Record<string, React.ComponentType> = {
  Dashboard: DashboardScreen,
  ProductosVenta: ProductosVentaScreen,
  InsumosInternos: InsumosInternosScreen,
  Formularios: FormulariosScreen,
  Jaulas: JaulasScreen,
  Contabilidad: ContabilidadScreen,
  Estadisticas: EstadisticasScreen,
  Salidas: SalidasScreen,
  Petshops: PetshopsScreen,
  Solicitudes: SolicitudesScreen,
  Proveedores: ProveedoresScreen,
  Comparativa: ComparativaPrecios,
  Archivos: ArchivosScreen,
  Alertas: AlertasScreen,
  Configuracion: ConfiguracionScreen,
};

export function AppRouter() {
  const perfil = useAuth((s) => s.perfil);
  const { current, setCurrent } = useNav();
  const allowed = useMemo(() => (perfil ? routesForRole(perfil.rol) : []), [perfil]);

  useEffect(() => {
    if (!allowed.find((r) => r.name === current)) {
      setCurrent(allowed[0]?.name ?? 'Dashboard');
    }
  }, [allowed, current, setCurrent]);

  const Screen = SCREENS[current] ?? DashboardScreen;

  return (
    <AppShell current={current} onNavigate={setCurrent}>
      <Screen />
    </AppShell>
  );
}
